import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Button, Spinner } from 'react-bootstrap';
import GradeForm from '../components/forms/GradeForm';
import '../styles/EmployeeMaster.css';
import GradeTable from '../components/GradeTable';

const GradeEditModel = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); // ✅ Get ID from route

  const [gradeData, setGradeData] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Show modal only if URL starts with /sbu/edit
  const showModal = location.pathname.startsWith('/grade/edit');

  const handleCloseModal = () => {
    navigate('/grade'); // Go back to list
  };

  // ✅ Fetch SBU details by ID
  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      fetch(`${baseUrl}/getGradeById/${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            setGradeData(data.data);
          } else {
            setGradeData(null);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching SBU by ID:', err);
          setLoading(false);
        });
    }
  }, [id, showModal]);

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Grade Master</h2>
      </div>

      {/* Table of SBUs */}
      <GradeTable />

      {/* Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Grade</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" /> Loading...
            </div>
          ) : gradeData ? (
            <GradeForm gradeId={id} initialData={gradeData} /> // ✅ Pass data to form
          ) : (
            <p className="text-center">No data found for this SBU.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary">
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default GradeEditModel;
